import React, { Component } from 'react';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import axios from 'axios';
import CustomLoader from '../../../common/CustomLoader';
import CustomSelect from '../../../../common/formElements/CustomSelect';
import * as actions from '../../../../features/events/redux/actions';
import { validateSubmitBtn } from '../../ActionFormUtils';
import FormFieldWithLabel from '../../../common/FormFieldWithLabel';
import {
  createActionSettingsSchema,
  getFieldInfoByName,
  validateFormDataSessionKey,
  validateItemIdBSLKey,
  validateResponseDataSessionKey,
} from '../collection/Util';
import { builderSurfaceJsonContentHeader } from '../../../../common/utils/restApiHeaderUtils';
import BrowserStorageLocationField from '../BrowserStorageLocationField';
import { FieldTypes } from 'drapcode-constant';
import BrowserStorageOptions from '../BrowserStorageOptions';
import { validationForFunctionExecution } from '../../../../common/formElements/CollectionSectionType';
import BrowserStoragePayload from '../BrowserStoragePayload';
import {
  SEND_ITEM_ID_FROM_OPTIONS_DESC,
  sendItemIdFromOptions,
} from '../../../../common/utils/event_constants';

class FunctionExecution extends Component {
  state = {
    customFunctions: [],
    apiError: null,
    showBSLOption: false,
  };

  componentDidMount() {
    const { projectId, version } = this.props;
    console.log('FunctionExecution componentDidMount - projectId:', projectId, 'version:', version);
    this.getCustomFunctions(projectId, version)
      .then((customFunctions) => {
        console.log('FunctionExecution API Response:', customFunctions);
        this.setState({ customFunctions: customFunctions.data || [] });
      })
      .catch((error) => {
        console.log('FunctionExecution API Error:', error);
        this.setState({ apiError: 'Failed to load functions. Please try again.' });
      });
  }

  RESET_ITEM_ID_FROM_VALUES = [
    'sendCurrentObjectID',
    'sendPreviousStepParentCollectionId',
    'sendCurrentPageItemId',
    'sendCurrentUserId',
    'sendTargetItemID',
    'sendCurrentPageReferenceItemId',
  ];

  SEND_ITEM_ID_FIELDS = [
    'sendTargetItemID',
    'sendCurrentObjectID',
    'sendPreviousStepParentCollectionId',
    'sendCurrentUserId',
    'sendCurrentPageItemId',
    'sendCurrentPageReferenceItemId',
  ];

  getCustomFunctionFromApi = async (projectId, version) => {
    const uri = `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/custom-function/`;
    const header = builderSurfaceJsonContentHeader(projectId);
    return axios.get(uri, header);
  };

  getCustomFunctions = async (projectId, version) => {
    const response = await this.getCustomFunctionFromApi(projectId, version);
    return response;
  };

  collectionOptions = () => {
    const customFunctionOptions = this.state.customFunctions
      .filter((func) => func.name)
      .map((func) => ({
        value: func.uuid,
        label: func.name,
      }));
    console.log('Dropdown options (functions only):', customFunctionOptions);
    return customFunctionOptions;
  };

  collectionsOptions = () => {
    const { events } = this.props;
    let options = [{ value: '', label: 'Choose Collection' }];
    let collections = events ? events.collections : [];
    if (collections.length > 0) {
      options = options.concat(
        collections.map((collection) => {
          return { value: collection.collectionName, label: collection.collectionTitle };
        }),
      );
    }
    return options;
  };

  collectionReferenceFieldsOptions = (values) => {
    const { events } = this.props;
    let options = [{ value: '', label: 'Choose Field' }];
    let collections = events ? events.collections : [];
    let collectionName = values['collection'] ? values['collection'] : '';
    if (collections.length > 0) {
      const collection = collections.find((coll) => coll.collectionName === collectionName);
      if (collection && collection.fields) {
        const collectionFields = collection.fields
          ? collection.fields.filter((e) =>
              [FieldTypes.reference.id, FieldTypes.createdBy.id, FieldTypes.belongsTo.id].includes(
                e.type,
              ),
            )
          : [];
        options = options.concat(
          collectionFields.map((field) => {
            if (field.fieldName) {
              const value =
                field.refCollection && field.refCollection.collectionName
                  ? `${field.fieldName}:${field.refCollection.collectionName}`
                  : '';
              return {
                value,
                label: field.fieldTitle.en,
              };
            }
          }),
        );
      }
    }
    return options;
  };

  handleSubmit = (values) => {
    console.log('handleSubmit called with values:', values);
    console.log('Props:', {
      actionData: this.props.actionData,
      eventAction: this.props.eventAction,
      selectedEvent: this.props.selectedEvent,
    });

    const { actionData, version, projectId, actions, selectedEvent } = this.props;
    let parameters = [];
    const hasSendItemIdFrom = !!values['sendItemIdFrom'];

    Object.keys(values).forEach((value) => {
      const action = actionData.args.find((param) => param.name === value);
      if (action) {
        parameters.push({
          name: value,
          value:
            hasSendItemIdFrom && this.RESET_ITEM_ID_FROM_VALUES.includes(value)
              ? ''
              : values[value],
          type: action.type,
        });
      }
    });

    if (values.FunctionName) {
      const selectedFunction = this.state.customFunctions.find(
        (func) => func.uuid === values.FunctionName,
      );
      console.log('🚀 ~ FunctionExecution ~ selectedFunction:', selectedFunction);
      if (selectedFunction && selectedFunction.url) {
        parameters.push({
          name: 'url',
          value: selectedFunction.url,
          type: 'text',
        });
        parameters.push({
          name: 'customFunctionUuid',
          value: selectedFunction.uuid,
          type: 'text',
        });
        parameters.push({
          name: 'customFunctionActionName',
          value: selectedFunction.functionName,
          type: 'text',
        });
      } else {
        console.log('Warning: No URL found for selected function');
      }
    }

    let actionFormData = this.props.eventAction;
    actionFormData.parameters = parameters;

    console.log('Calling updateAction with:', {
      projectId,
      version,
      eventId: selectedEvent && selectedEvent.uuid,
      data: actionFormData,
    });

    actions
      .updateAction({
        projectId,
        version,
        eventId: selectedEvent && selectedEvent.uuid,
        data: actionFormData,
      })
      .then(() => {
        console.log('Action updated successfully');
        this.props.hideModal();
      })
      .catch((error) => {
        console.log('Action update failed:', error);
      });
  };

  renderSendItemIdFrom = (setFieldValue, setFieldTouched, values) => {
    // Fallback handling of Checkbox field values in the Dropdown
    if (!values['sendItemIdFrom']) {
      if (values['sendCurrentObjectID']) {
        values['sendItemIdFrom'] = 'sendCurrentObjectID';
        values['sendCurrentObjectID'] = '';
      } else if (values['sendCurrentPageItemId']) {
        values['sendItemIdFrom'] = 'sendCurrentPageItemId';
        values['sendCurrentPageItemId'] = '';
      } else if (values['sendCurrentPageReferenceItemId']) {
        values['sendItemIdFrom'] = 'sendCurrentPageReferenceItemId';
        values['sendCurrentPageReferenceItemId'] = '';
      } else if (values['sendCurrentUserId']) {
        values['sendItemIdFrom'] = 'sendCurrentUserId';
        values['sendCurrentUserId'] = '';
      } else if (values['sendPreviousStepParentCollectionId']) {
        values['sendItemIdFrom'] = 'sendPreviousStepParentCollectionId';
        values['sendPreviousStepParentCollectionId'] = '';
      } else if (values['sendTargetItemID']) {
        values['sendItemIdFrom'] = 'sendTargetItemID';
        values['sendTargetItemID'] = '';
      }
    }

    return (
      <div className="form-group">
        <FormFieldWithLabel
          cta={false}
          label="Send Item ID From"
          icon="select"
          infoIcon={true}
          infoDescription={SEND_ITEM_ID_FROM_OPTIONS_DESC}
        >
          <CustomSelect
            name={'sendItemIdFrom'}
            isMulti={false}
            onChange={setFieldValue}
            onBlur={setFieldTouched}
            options={sendItemIdFromOptions()}
            value={values['sendItemIdFrom']}
          />
          <ErrorMessage name={'sendItemIdFrom'}>
            {(msg) => <p className="text-error">{msg}</p>}
          </ErrorMessage>
        </FormFieldWithLabel>
      </div>
    );
  };

  isSendCurrentPageReferenceItemIdEnabled = (values) => {
    let isEnabled = false;
    if (!values['sendItemIdFrom']) {
      isEnabled = !!values['sendCurrentPageReferenceItemId'];
    } else {
      isEnabled = values['sendItemIdFrom'] === 'sendCurrentPageReferenceItemId';
    }
    return isEnabled;
  };

  isSendBSLItemIdEnabled = (values) => {
    return values['sendItemIdFrom'] === 'sendBSLItemId';
  };

  bslOptionHandler = () => {
    this.setState({
      showBSLOption: !this.state.showBSLOption,
    });
  };

  render() {
    const { eventAction, actionData } = this.props;
    const { showBSLOption } = this.state;

    return (
      <Formik
        enableReinitialize={true}
        initialValues={createActionSettingsSchema(actionData, eventAction)}
        validationSchema={validationForFunctionExecution()}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          console.log('Form submitting with values:', values);
          this.handleSubmit(values);
          setSubmitting(false);
          resetForm();
        }}
      >
        {({ isSubmitting, values, setFieldValue, setFieldTouched, errors }) => (
          <Form>
            {this.state.apiError && <p className="text-error">{this.state.apiError}</p>}
            <div className="row">
              <div className="col-12">
                <div className="form-group">
                  <FormFieldWithLabel
                    cta={false}
                    label="Function"
                    icon="select"
                    infoIcon={true}
                    infoDescription={getFieldInfoByName('FunctionName')}
                  >
                    <CustomSelect
                      name="FunctionName"
                      isMulti={false}
                      onChange={(name, value) => {
                        console.log('CustomSelect changed:', { name, value });
                        setFieldValue(name, value);
                      }}
                      onBlur={setFieldTouched}
                      options={this.collectionOptions()}
                      value={values['FunctionName']}
                      placeholder="Select Function"
                    />
                    <ErrorMessage name="FunctionName">
                      {(msg) => <p className="text-error">{msg}</p>}
                    </ErrorMessage>
                  </FormFieldWithLabel>
                </div>
                {/* Send Item ID From Section */}
                {this.renderSendItemIdFrom(setFieldValue, setFieldTouched, values)}
                {/* Conditional fields based on Send Item ID From selection */}
                {this.isSendCurrentPageReferenceItemIdEnabled(values) && (
                  <>
                    <div className="form-group">
                      <FormFieldWithLabel
                        cta={false}
                        label="Current Page Collection"
                        icon="select"
                        infoIcon={true}
                        infoDescription={'Select Collection'}
                      >
                        <CustomSelect
                          name={'collection'}
                          isMulti={false}
                          onChange={setFieldValue}
                          onBlur={setFieldTouched}
                          options={this.collectionsOptions()}
                          value={values['collection']}
                        />
                        <ErrorMessage name={'collection'}>
                          {(msg) => <p className="text-error">{msg}</p>}
                        </ErrorMessage>
                      </FormFieldWithLabel>
                    </div>
                    {values['collection'] && (
                      <div className="form-group">
                        <FormFieldWithLabel
                          cta={false}
                          label="Reference Field"
                          icon="select"
                          infoIcon={true}
                          infoDescription={'Select Reference Field'}
                        >
                          <CustomSelect
                            name={'referenceField'}
                            isMulti={false}
                            onChange={setFieldValue}
                            onBlur={setFieldTouched}
                            options={this.collectionReferenceFieldsOptions(values)}
                            value={values['referenceField']}
                          />
                          <ErrorMessage name={'referenceField'}>
                            {(msg) => <p className="text-error">{msg}</p>}
                          </ErrorMessage>
                        </FormFieldWithLabel>
                      </div>
                    )}
                  </>
                )}
                {this.isSendBSLItemIdEnabled(values) && (
                  <>
                    <div className="form-group">
                      <FormFieldWithLabel
                        cta={false}
                        label="Item Collection"
                        icon="select"
                        infoIcon={true}
                        infoDescription={'Item Collection'}
                      >
                        <CustomSelect
                          name={'bslCollection'}
                          isMulti={false}
                          onChange={setFieldValue}
                          onBlur={setFieldTouched}
                          options={this.collectionsOptions()}
                          value={values['bslCollection']}
                        />
                        <ErrorMessage name={'bslCollection'}>
                          {(msg) => <p className="text-error">{msg}</p>}
                        </ErrorMessage>
                      </FormFieldWithLabel>
                    </div>
                    {values['bslCollection'] && (
                      <>
                        <BrowserStorageLocationField
                          fieldName={'browserStorageLocation'}
                          values={values}
                          description={
                            'Select a browser storage location to get an Item ID key (Default: Session Storage).'
                          }
                          setFieldValue={setFieldValue}
                          setFieldTouched={setFieldTouched}
                        />
                        <div className="form-group">
                          <FormFieldWithLabel
                            cta={false}
                            label="Item ID JSON Key"
                            icon="text"
                            infoIcon={true}
                            infoDescription={`Enter the key which contains Item ID value in your web browser storage.`}
                          >
                            <Field
                              type="text"
                              name="itemIdBSLKey"
                              className="form-control form-control-sm"
                              autoComplete="off"
                              placeholder="Item ID JSON Key Eg. Key1 or, Parent_Key1.Child_Key[0]"
                              validate={validateItemIdBSLKey}
                            />
                          </FormFieldWithLabel>
                          <ErrorMessage name={'itemIdBSLKey'}>
                            {(msg) => <p className="text-error ml-5">{msg}</p>}
                          </ErrorMessage>
                        </div>
                      </>
                    )}
                  </>
                )}
                <div className="form-group">
                  <FormFieldWithLabel
                    cta={false}
                    label="Success Message"
                    icon="text"
                    infoIcon={true}
                    infoDescription={`Success message (optional).`}
                  >
                    <Field
                      type="text"
                      name="successMessage"
                      className="form-control form-control-sm"
                      autoComplete="off"
                      placeholder="Success Message"
                    />
                    <ErrorMessage name="successMessage">
                      {(msg) => <p className="texterror">{msg}</p>}
                    </ErrorMessage>
                  </FormFieldWithLabel>
                </div>
                <div className="form-group">
                  <FormFieldWithLabel
                    cta={false}
                    label="Error Message"
                    icon="text"
                    infoIcon={true}
                    infoDescription={`Error message (optional).`}
                  >
                    <Field
                      type="text"
                      name="errorMessage"
                      className="form-control form-control-sm"
                      autoComplete="off"
                      placeholder="Error Message"
                    />
                    <ErrorMessage name="errorMessage">
                      {(msg) => <p className="texterror">{msg}</p>}
                    </ErrorMessage>
                  </FormFieldWithLabel>
                </div>
                <BrowserStoragePayload
                  values={values}
                  label={'Send Browser Storage Data From'}
                  infoDescription={
                    'Select a browser storage locations from where you want to send data as a payload to Custom Function.'
                  }
                  description={
                    "Select a browser storage location's data to be sent to Custom Function."
                  }
                  setFieldValue={setFieldValue}
                  setFieldTouched={setFieldTouched}
                  showDefaultOption={false}
                />
                <div className="form-group">
                  <button
                    onClick={(e) => this.bslOptionHandler(e)}
                    className="btn btn-icon-only btn-outline-info ml-5 p-1"
                    title="Show Browser Storage Options"
                    type="button"
                  >
                    <i className="wb webconnect-cog"></i>&nbsp;Browser Storage Options
                  </button>
                </div>
                {showBSLOption && (
                  <BrowserStorageOptions
                    values={values}
                    setFieldValue={setFieldValue}
                    setFieldTouched={setFieldTouched}
                    validateFormDataSessionKey={validateFormDataSessionKey}
                    validateResponseDataSessionKey={validateResponseDataSessionKey}
                    sendPreviousActionResponseItemId={false}
                  />
                )}
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 text-left">
                <button
                  type="button"
                  className="btn btn-outline-secondary btn-sm"
                  onClick={() => {
                    console.log('Cancel clicked');
                    this.props.hideModal();
                  }}
                >
                  <span>
                    <i className="wb webconnect-times"></i> Cancel
                  </span>
                </button>
              </div>
              <div className="col-md-6 text-right">
                <button
                  type="submit"
                  disabled={validateSubmitBtn(values, eventAction) || isSubmitting}
                  className={`btn btn-sm ${
                    validateSubmitBtn(values, eventAction) || isSubmitting
                      ? 'btn-default'
                      : 'btn-theme-submit'
                  }`}
                  onClick={() =>
                    console.log(
                      'Save clicked, values:',
                      values,
                      'validateSubmitBtn:',
                      validateSubmitBtn(values, eventAction),
                    )
                  }
                >
                  <i className="wb webconnect-save-regular"></i> Save
                  <CustomLoader loading={this.props.showLoaderForAction} />
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    );
  }
}

function mapStateToProps(state) {
  return { event: state.event };
}

function mapDispatchToProps(dispatch) {
  return { actions: bindActionCreators({ ...actions }, dispatch) };
}

export default connect(mapStateToProps, mapDispatchToProps)(FunctionExecution);
